
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaBell, FaCog, FaGlobe } from 'react-icons/fa';

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <header className="bg-white shadow-md p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <FaGlobe className="text-blue-500" />
        </div>
        <div className="flex items-center space-x-4">
          <FaSearch className="text-gray-500 cursor-pointer" />
          <FaBell className="text-gray-500 cursor-pointer" />
          <FaCog className="text-gray-500 cursor-pointer" />
          <div>
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-full"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
